import { IConnectionActionTypes } from "../action-types/IConnectionActionTypes";
import { eReducerStatusBase } from "../reducer-model/eReducerStatusBase";
import { IConnectionReducer } from "../reducer-model/IConnectionReducer";

const iniState: IConnectionReducer = {
    connections: localStorage.getItem("connections") ? JSON.parse(localStorage.getItem("connections") ?? "") : [],
    connectionsData: {}
}
export const connectionReuducer = (state: IConnectionReducer = iniState, actions: IConnectionActionTypes): IConnectionReducer => {

    switch (actions.type) {
        case "CONNECTION_CHANGE_CONNECTIONS":
            localStorage.setItem("connections", JSON.stringify(actions.payload))
            return {
                ...state,
                connections: actions.payload
            }
        case "CONNECTION_CHANGE_SELECTED_ID": {
            return {
                ...state,
                connectionSelctedId: actions.payload
            }
        }
        case "CONNECTION_GENERATE_START":
            return {
                ...state,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.id]: {
                        ...state.connectionsData[actions.payload.id],
                        status: eReducerStatusBase.is_saving
                    }
                }
            }
        case "CONNECTION_GENERATE_SUCCESS":
            let newConnection = [...state.connections];
            const idx = newConnection.findIndex(x => x.id === actions.payload.connection.id);
            if (idx < 0) {
                newConnection.push({
                    ...actions.payload.connection,
                    password: "",
                    rsa_password: actions.payload.data.rsa_password
                })
            } else {
                newConnection[idx] = {
                    ...actions.payload.connection,
                    password: "",
                    rsa_password: actions.payload.data.rsa_password
                }
            }
            localStorage.setItem("connections", JSON.stringify(newConnection))
            return {
                ...state,
                connections: newConnection,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.connection.id]: {
                        ...state.connectionsData[actions.payload.connection.id],
                        status: eReducerStatusBase.is_completed,
                        data: actions.payload.data
                    }
                }
            }
        case "CONNECTION_GENERATE_ERROR":
            return {
                ...state,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.connection.id]: {
                        ...state.connectionsData[actions.payload.connection.id],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            }
        case "CONNECTION_CHANGE_SEARCH_KEY":
            return {
                ...state,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.connectionId]: {
                        ...state.connectionsData[actions.payload.connectionId],
                        searchKey: actions.payload.data
                    }
                }
            }
        case "CONNECTION_CHANGE_SELECTED_TABLE":
            return {
                ...state,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.connectionId]: {
                        ...state.connectionsData[actions.payload.connectionId],
                        selectedTable: actions.payload.data
                    }
                }
            }
        case "CONNECTION_CHANGE_SELECTED_TAB":
            return {
                ...state,
                connectionsData: {
                    ...state.connectionsData,
                    [actions.payload.connectionId]: {
                        ...state.connectionsData[actions.payload.connectionId],
                        selectedTab: actions.payload.data
                    }
                }
            }
        default:
            return { ...state }
    }
}